import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import Layout from "./Layout/Layout"
import { FilterProvider, ModalProvider, UserProvider, CategoryProvider, EventProvider, TourProvider } from "../context/index"
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client'
import { APP_GRAPHQL, RECAPTCHA_SITE_KEY } from '../constant'
import { registerLocale } from "react-datepicker"
import ru from 'date-fns/locale/ru'
import 'moment/locale/ru'
registerLocale('ru', ru)


const client = new ApolloClient({
	uri: APP_GRAPHQL,
	cache: new InMemoryCache({})
});

function App (){
	return (
		<ApolloProvider client={client}>
			<GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
				<TourProvider>
					<UserProvider>
						<FilterProvider>
							<CategoryProvider>
								<EventProvider>
									<ModalProvider>
										<Layout/>
									</ModalProvider>
								</EventProvider>
							</CategoryProvider>
						</FilterProvider>
					</UserProvider>
				</TourProvider>
			</GoogleReCaptchaProvider>
		</ApolloProvider>
	);
}

export default App;